import { t } from "i18next";
import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/colors";
import Typography from "../typography/Typography";

interface IUploadIcon {
  handleLoadFile: (event: any) => void;
  idForUploadButton?: string;
  size?: number;
}

const IconContainer = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const Icon = styled.label`
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    margin-bottom: 4px;
    height: 38px;
    width: 38px;

    transition: all 0.5s;

    &:hover {
        cursor: pointer;
        background-color: ${props => props.theme.colors.inputBackground};
    }

    &:active {
        background-color: ${props => props.theme.colors.border};
    }
`;

const UploadIcon: React.FC<IUploadIcon> = ({
  handleLoadFile,
  idForUploadButton,
  size=20
}) => {

  return (
    <IconContainer>
        <Icon htmlFor={idForUploadButton} >
          <svg
            width={size}
            height={size}
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 16V19C1 20.1046 1.89543 21 3 21H17C18.1046 21 19 20.1046 19 19V16"
              stroke={colors.secondary}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 5L10 1L6 5"
              stroke={colors.secondary}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 1V15"
              stroke={colors.secondary}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Icon>
      <input
        type="file"
        id={idForUploadButton}
        accept="image/*"
        style={{ display: "none" }}
        onChange={(event) => handleLoadFile(event)}
      />
      <Typography type="paragraphXS" color="title" >{t('change')}</Typography>
    </IconContainer>
  );
};

export default UploadIcon;
